import React from 'react';
import { motion } from 'framer-motion';
import { Truck, Package, Clock } from 'lucide-react';
export function Delivery() {
  return <section className="py-24 bg-brand-cream" data-id="element-147" data-mp="10foy591xcrfa">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-148" data-mp="vhx70h93t9c5">
        <div className="text-center mb-16" data-id="element-149" data-mp="vifb2020crum">
          <h2 className="text-4xl md:text-5xl font-serif text-brand-dark mb-4" data-id="element-150" data-mp="qjlw0372ossc">
            Інформація про доставку
          </h2>
          <p className="text-brand-dark/70 max-w-2xl mx-auto" data-id="element-151" data-mp="1o5jalpic0dz0">
            Ми дбаємо про те, щоб ваші речі прибули безпечно та вчасно.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-152" data-mp="1egrj1ih6nvom">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-2xl text-center border border-brand-beige" data-id="element-153" data-mp="1eeyc022nr9g3">
            <div className="w-16 h-16 mx-auto bg-brand-cream rounded-full flex items-center justify-center mb-6" data-id="element-154" data-mp="xwgtebvpq85h">
              <Truck className="w-8 h-8 text-brand-burgundy" data-id="element-155" data-mp="12tz2q3dn6pe0" />
            </div>
            <h3 className="text-xl font-serif text-brand-dark mb-3" data-id="element-156" data-mp="o4ktcva2g7ym">
              Нова Пошта
            </h3>
            <p className="text-brand-dark/70 mb-4" data-id="element-157" data-mp="t3e62lhj3uxq">
              Швидка та надійна доставка по Україні до найближчого відділення
              або поштомату.
            </p>
            <p className="text-sm font-medium text-brand-burgundy" data-id="element-158" data-mp="j6rny4gl7hze">
              1-3 Робочі дні
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-white p-8 rounded-2xl text-center border border-brand-beige" data-id="element-159" data-mp="58b73kp0gb3j">
            <div className="w-16 h-16 mx-auto bg-brand-cream rounded-full flex items-center justify-center mb-6" data-id="element-160" data-mp="230cc1n6dwc7z">
              <Package className="w-8 h-8 text-brand-burgundy" data-id="element-161" data-mp="1t499whbj8dl1" />
            </div>
            <h3 className="text-xl font-serif text-brand-dark mb-3" data-id="element-162" data-mp="1t6c83omu9d0u">
              Безкоштовна доставка
            </h3>
            <p className="text-brand-dark/70 mb-4" data-id="element-163" data-mp="2lswzgp3bdp4e">
              Ми пропонуємо безкоштовну доставку Новою Поштою для всіх замовлень
              на суму понад 5000 ₴.
            </p>
            <p className="text-sm font-medium text-brand-burgundy" data-id="element-164" data-mp="2c3dhdlnfdzal">
              Для замовлень від 5000 ₴
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} className="bg-white p-8 rounded-2xl text-center border border-brand-beige" data-id="element-165" data-mp="2738vfg3r0ccz">
            <div className="w-16 h-16 mx-auto bg-brand-cream rounded-full flex items-center justify-center mb-6" data-id="element-166" data-mp="3c3gxstxzjqip">
              <Clock className="w-8 h-8 text-brand-burgundy" data-id="element-167" data-mp="3h4msuyf4bpve" />
            </div>
            <h3 className="text-xl font-serif text-brand-dark mb-3" data-id="element-168" data-mp="3m2ocbkgghr7e">
              Міжнародна
            </h3>
            <p className="text-brand-dark/70 mb-4" data-id="element-169" data-mp="3qydd1r47pe5a">
              Доступна доставка по всьому світу через Укрпошту. Терміни доставки
              залежать від країни призначення.
            </p>
            <p className="text-sm font-medium text-brand-burgundy" data-id="element-170" data-mp="3pgphytx17br">
              14-30 Робочих днів
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}